import { Utils } from "../utilities/Utils";

export interface IBookingProfile {
    id: string;
    guid: string;
    bookingID: number;
    date: Date;
    noOfRooms: number;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
}

export class BookingProfile implements IBookingProfile {

    constructor(data?: IBookingProfile) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingProfile) {
        Utils.clone(data, this);
    }

    id: string = "";
    guid: string = Utils.emptyGuidValue;
    bookingID: number = 0;
    date: Date = new Date(Utils.emptyDateValue);
    noOfRooms: number = 0;
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
}